import axios from 'axios';
import { ACCESS_TYPE, ROUTE_STATUS, VENDING_URL } from '../../atoms/const';
import getScheduleByIdRes from './getScheduleById.json';

const getByDateRange = (startDate?: string, endDate?: string, page?: number, size?: number) => {
  /* format date 04/01/2021 */
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-schedule-by-date?startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get(url, config);
};

const getPDFByScheduleId = (id: number | null) => {
  /* format date 04/01/2021 */
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}route-sales-pdf?schId=${id}&descending=false`;
  return axios.get(url, {
    responseType: 'blob',
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  });
};

const deleteById = (data: { id: number }) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}cancel-route`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

interface addScheduleData {
  'routeId': string,
  'scheduleDate': string,
  'userId': string,
  'sendEmail': boolean,
  'sendSms': boolean
}

const add = (data: addScheduleData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}schedule-route`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

const getById = (id: string) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-schedule-route?scheduleId=${id}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getScheduleByIdRes>(url, config);
};

interface StatusHandlerData {
  id: number;
  status: number | null
}

const statusHandler = (data: StatusHandlerData) => {
  const token = sessionStorage.getItem('token');
  const url = () => {
    if (data.status === null || data.status === ROUTE_STATUS.DEFAULT) {
      return `${VENDING_URL}set-picking-ready`;
    }
    if (
      data.status === ROUTE_STATUS.READY_TO_PICKING
      || data.status === ROUTE_STATUS.FINISH_PICKING
    ) {
      return `${VENDING_URL}set-driver-ready`;
    }
    throw new Error('This route status cannot be changed manually.');
  };
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url(), { id: data.id }, config);
};

interface addClientToScheduleData {
  'id': number;
  'clients': number[]
}

const addClientToSchedule = (data: addClientToScheduleData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}add-client-to-schedule`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { ...data }, config);
};

interface UpdateDriver {
  'id': number;
  'userId': number;
  'scheduleDate': string;
}

const updateDriver = (data: UpdateDriver) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}update-schedule`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { ...data }, config);
};

interface UpdateScheduleDate {
  'id': number;
  'scheduleDate': string;
}
const updateScheduleDate = (data: UpdateScheduleDate) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}update-schedule-date`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { ...data }, config);
};

interface RemoveVMFromSchedule {
  'id': number;
  'vmId': number[];
}

const removeVMFromSchedule = (data: RemoveVMFromSchedule) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}remove-vm-from-schedule`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { ...data }, config);
};

interface SendCoffeeOrderForm {
  'id': number;
  'vmId': number[];
  'sendEmail': boolean,
  'sendSMS': boolean,
}
const sendCoffeeOrderFrom = (data: SendCoffeeOrderForm) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}send-coffee-order-form`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { ...data }, config);
};

interface SalesItem {
  'vmInvId': number;
  'price': number;
  'quantity': number;
}

interface UpdateCoffeeOrder {
  'vmId': number;
  'dropDate': string;
  'routeScheduleId': number;
  'salesItems': SalesItem[];
}

const updateCoffeeOrder = (data: UpdateCoffeeOrder) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}ocs-add-invoice`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { ...data }, config);
};

const schedules = {
  getByDateRange,
  getPDFByScheduleId,
  deleteById,
  add,
  getById,
  statusHandler,
  addClientToSchedule,
  updateDriver,
  removeVMFromSchedule,
  sendCoffeeOrderFrom,
  updateCoffeeOrder,
};

export default schedules;
